export const REMINDER = "REMINDER";
export const REMINDER_SUCCESS = "REMINDER_SUCCESS";
export const REMINDER_FAILED = "REMINDER_FAILED";

export const ADD_REMINDER = "ADD_REMINDER";
export const ADD_REMINDER_SUCCESS = "ADD_REMINDER_SUCCESS";
export const ADD_REMINDER_FAILED = "ADD_REMINDER_FAILED";

export const UPDATE_REMINDER = "UPDATE_REMINDER";
export const UPDATE_REMINDER_SUCCESS = "UPDATE_REMINDER_SUCCESS";
export const UPDATE_REMINDER_FAILED = "UPDATE_REMINDER_FAILED";